export default __webpack_public_path__ + "static/media/health.c821eba7.png";